import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: (data) => apiClient.post('/auth/register', data),
  login: (data) => apiClient.post('/auth/login', data),
  getCurrentUser: () => apiClient.get('/auth/me')
};

// Organizations API
export const organizationsAPI = {
  getAll: (wasteStream = null) => apiClient.get('/organizations', { 
    params: wasteStream ? { waste_stream: wasteStream } : {} 
  }),
  getById: (id) => apiClient.get(`/organizations/${id}`)
};

// Calculations API
export const calculationsAPI = {
  calculate: (data) => apiClient.post('/calculate', data),
  calculateMultiyear: (data) => apiClient.post('/calculate-multiyear', data),
  getHistory: () => apiClient.get('/calculations'),
  getById: (id) => apiClient.get(`/calculations/${id}`),
  generatePDF: (id) => apiClient.post(`/generate-pdf/${id}`),
  downloadPDF: (id) => apiClient.get(`/download-pdf/${id}`, { responseType: 'blob' })
};

// Admin API
export const adminAPI = {
  getStats: () => apiClient.get('/admin/stats'),
  getAllCalculations: () => apiClient.get('/admin/calculations'),
  getAllUsers: () => apiClient.get('/admin/users'),
  updateUserRole: (id, role) => apiClient.put(`/admin/users/${id}?role=${role}`),
  deleteUser: (id) => apiClient.delete(`/admin/users/${id}`),
  approveUser: (id) => apiClient.post(`/admin/users/${id}/approve`),
  rejectUser: (id) => apiClient.post(`/admin/users/${id}/reject`),
  createOrganization: (data) => apiClient.post('/organizations', data),
  updateOrganization: (id, data) => apiClient.put(`/organizations/${id}`, data),
  deleteOrganization: (id) => apiClient.delete(`/organizations/${id}`),
  createNotification: (data) => apiClient.post('/notifications', data)
};

// Notifications API
export const notificationsAPI = {
  getAll: (unreadOnly = false) => apiClient.get('/notifications', { params: { unread_only: unreadOnly } }),
  getUnreadCount: () => apiClient.get('/notifications/unread-count'),
  markAsRead: (id) => apiClient.post(`/notifications/${id}/read`),
  markAllAsRead: () => apiClient.post('/notifications/read-all'),
  delete: (id) => apiClient.delete(`/notifications/${id}`)
};

export default apiClient;
